import { Checkbox, FormControlLabel, Grid, IconButton } from "@mui/material";
import { FieldArray } from "formik";
import Api from "../../../api2";
import { MySelect } from "../../Lib/componentLibrarys";
import { useEffect, useState } from "react";
import { ExpandLess, ExpandMore, Remove } from "@mui/icons-material";

export const FormNhap = ({ values, setFieldValue }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const updateParentEditState = () => {
    values?.fieldChucNangs?.forEach((item, index) => {
      if (item.children?.length > 0) {
        const allChildrenEdit = item.children.every((child) => child.ischeck);
        setFieldValue(`fieldChucNangs.[${index}].ischeck`, allChildrenEdit);
      }
    });
  };

  useEffect(() => {
    updateParentEditState();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      updateParentEditState();
    }, 0);
  }, [values.fieldChucNangs]);

  const toggleExpand = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <div style={{ textAlign: 'center' }} className="title-page-cau-hinh-hien-thi">Phân quyền chức năng</div>
        <FieldArray
          name="fieldChucNangs"
          render={(arrayHelpers) => (
            <Grid container spacing={1} style={{ marginLeft: "10px" }}>
              {values?.fieldChucNangs?.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {item.children?.length > 0 ? (
                      <IconButton size="small" onClick={() => toggleExpand(index)}>
                        {expandedItems[index] ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    ) : (
                      <IconButton size="small" disabled>
                        <Remove />
                      </IconButton>
                    )}
                    <FormControlLabel
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "350px",
                        alignItems: "center",
                      }}
                      control={
                        <Checkbox
                          checked={item.ischeck}
                          onChange={(event) => {
                            const newIsEdit = event.target.checked;
                            setFieldValue(`fieldChucNangs.[${index}].ischeck`, newIsEdit);
                            if (item.children?.length > 0) {
                              item.children.forEach((_, childIndex) => {
                                setFieldValue(
                                  `fieldChucNangs.[${index}].children.[${childIndex}].ischeck`,
                                  newIsEdit
                                );
                              });
                            }
                            setTimeout(() => {
                              updateParentEditState();
                            }, 0);
                          }}
                        />
                      }
                      label={item.name}
                      labelPlacement="start"
                    />
                  </div>
                  {expandedItems[index] &&
                    item.children?.map((child, childIndex) => (
                      <Grid item xs={12} key={child.id} style={{ paddingLeft: "5.281rem"}}>
                        <FormControlLabel
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "300px",
                            alignItems: "center"
                          }}
                          control={
                            <Checkbox
                              checked={child.ischeck}
                              onChange={(event) => {
                                setFieldValue(
                                  `fieldChucNangs.[${index}].children.[${childIndex}].ischeck`,
                                  event.target.checked
                                );
                                setTimeout(() => {
                                  updateParentEditState();
                                }, 0);
                              }}
                            />
                          }
                          label={<span style={{ marginLeft: "0px" }}>{child.name}</span>}
                          labelPlacement="start"
                        />
                      </Grid>
                    ))}
                </Grid>
              ))}
            </Grid>
          )}
        />
      </Grid>
    </div>
  );
};

export const FormInputData = ({ values, errors, setFieldValue, linhVucList, profile }) => {
  const [appList, setAppList] = useState([]);
  const [roleList, setRoleList] = useState([]);

  const getApiListApp = (idlinhvuc, page, size) => {
    new Api()
      .GetAppByIdLinhVuc({ idlinhvuc: idlinhvuc, page: page || 1, size: size || 100 })
      .then(data => {
        if (data.code === 200) {
          setAppList(data?.data?.result?.data);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };

  const getApiListRole = (cap, idlinhvuc) => {
    new Api()
      .GetRolesByCap({ cap: cap, idlinhvuc: idlinhvuc })
      .then(data => {
        if (data.code === 200) {
          setRoleList(data?.data?.result);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <div style={{ textAlign: 'center' }} className="title-page-cau-hinh-hien-thi">Chọn thông tin nhóm người dùng</div>
        <Grid item xs={12}>
          <MySelect
            required
            label="Lĩnh vực:"
            placeholder="Chọn..."
            value={values?.linhVuc}
            options={linhVucList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`linhVuc`, value);
            }}
            errors={errors?.linhVuc}
            helperText={errors?.linhVuc}
          />
        </Grid>
        <Grid item xs={12}>
          <MySelect
            required
            label="Ứng dụng:"
            placeholder="Chọn..."
            value={values?.app}
            options={appList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`app`, value);
            }}
            errors={errors?.app}
            helperText={errors?.app}
            onOpen={() => {
              values?.linhVuc?.id &&
              getApiListApp(values.linhVuc.id, 1, 100);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MySelect
            required
            label="Nhóm người dùng:"
            placeholder="Chọn..."
            value={values?.role}
            options={roleList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`role`, value);
            }}
            errors={errors?.role}
            helperText={errors?.role}
            onOpen={() => {
              values?.linhVuc?.id &&
              getApiListRole(profile?.cap, values.linhVuc.id);
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};
